import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../components/DraggableModal";
import { EntProduct } from "../../../models/product";
import SelectMultiProductType from "../../../components/selects/SelectMultiProductType";

enum FormField {
    productsTypeIds,
    areaId,
    countProduction,
    countSales,
}

interface IProps {
    show: boolean;
    product: EntProduct;
    onHide: () => void;
    onSubmit: (pos: EntProduct) => Promise<boolean>;
}

export const AddProductModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        const productTypeIds = props.product.productsTypes?.map(type => type.id) || [];
        form.setFields([
            { name: FormField.productsTypeIds, value: productTypeIds },
            { name: FormField.areaId, value: props.product.area?.id },
            { name: FormField.countProduction, value: props.product.countProduction },
            { name: FormField.countSales, value: props.product.countSales },
        ]);
    };

    const setEntityFromFields = (): EntProduct=> {
        let farmOwner = _.cloneDeep(props.product);
        farmOwner.productsTypeIds = form.getFieldValue(FormField.productsTypeIds);
        farmOwner.areaId = form.getFieldValue(FormField.areaId);
        farmOwner.countProduction = form.getFieldValue(FormField.countProduction);
        farmOwner.countSales = form.getFieldValue(FormField.countSales);
        return farmOwner;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);
            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.product.id === 0 ? t('product.add_register_of_productions') : t('product.edit_register_of_productions')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Form.Item
                        label={ t('product.product_type') }
                        name={FormField.productsTypeIds}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <SelectMultiProductType />
                    </Form.Item>
                    <Form.Item
                        label={ t('product.quantity_of_products_produced') }
                        name={FormField.countProduction}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input type="text" />
                    </Form.Item>
                    <Form.Item
                        label={ t('product.number_of_sales') }
                        name={FormField.countSales}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input type="text" />
                    </Form.Item>
                 
                </Form>
            </DraggableModal>
        </>
    )
}
